module.exports = __webpack_public_path__ + "img/satellite.7d334df1.jpg";